import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import { FormAppCode } from './FormAppCode';
import { DeleteAppCode } from './DeleteAppCode';
import { Dialog } from 'primereact/dialog';

export const ModalAppCode = (props) => {

    const {
        modal, modalTitle, toggle, method,
        validaciones,
        brands, machineModels, infoAnalytes, methods,
        id_brand, id_analyzer, id_machine_model, id_info_analyte, code, convertion_factor, array_methods_ids,
        handleInputChange, handleValueSelect, handleMethods, loading, metodosSelect,
        saveCreate, saveUpdate,
        validacionAnalyte,saveDelete
        //  saveUpdate, saveDelete
    } = props;

    return (

          <Dialog
            header={modalTitle}
            visible={modal}
            onHide={toggle}
            style={{ width: '900px', maxWidth: '95vw' }}
            blockScroll={true}
            modal={true}
            closable={true}
            className="large-dialog"
            headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold'
            }}
        >
          
        {
            method === "create"
                ? <FormAppCode
                    button={"Crear nuevo"}
                    {...{
                        validacionAnalyte, brands, machineModels, infoAnalytes, methods,
                        id_brand, id_analyzer, id_machine_model, id_info_analyte, code, convertion_factor, array_methods_ids, metodosSelect,
                        toggle, loading, handleInputChange, handleValueSelect, handleMethods, validaciones, methodAction: saveCreate
                    }}
                />
                : (method === "update")
                    ? <FormAppCode
                        button={"Editar"}
                        {...{
                            validacionAnalyte, brands, machineModels, infoAnalytes, methods,
                            id_brand, id_analyzer, id_machine_model, id_info_analyte, code, convertion_factor, array_methods_ids, metodosSelect,
                            toggle, loading, handleInputChange, handleValueSelect, handleMethods, validaciones, methodAction: saveUpdate
                        }}
                    />
                    : <DeleteAppCode
                            {...{ toggle, loading, saveDelete }}
                        />
        }
        </Dialog>
    )
};
